import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import type { DocumentType } from "generated-graphql/graphql";
import { GET_ACCEPTABLE_FILE_FORMATS_BY_DOCUMENT_TYPE } from "../queries";

type UseAcceptableFileFormatsParams = {
  tenantId: string;
  facilityId?: string;
  documentType?: DocumentType;
};

export function useAcceptableFileFormats({
  tenantId,
  facilityId,
  documentType,
}: UseAcceptableFileFormatsParams) {
  const { data } = useQuery(GET_ACCEPTABLE_FILE_FORMATS_BY_DOCUMENT_TYPE, {
    variables: {
      tenantId,
      facilityId: facilityId ?? "",
    },
    skip: !tenantId || !facilityId,
  });

  const acceptableFileFormats = useMemo(() => {
    if (documentType && data?.getAcceptableFileFormatsByDocumentType) {
      return (
        data.getAcceptableFileFormatsByDocumentType.find(
          (formats) => formats.documentType === documentType
        )?.fileFormats ?? []
      );
    }

    return [];
  }, [data?.getAcceptableFileFormatsByDocumentType, documentType]);

  return acceptableFileFormats;
}
